<template>
  <v-form
    ref="form"
    lazy-validation
    class="geofence-form"
  >
    <v-card class="geofence-card">
      <div>
        <v-card-title class="justify-space-between">
          <div class="d-flex gap5">
            <v-icon
              class="redirect-btn"
              @click="redirect"
            >
              mdi-arrow-left
            </v-icon>
            <span class="text-h3 text-capitalize">{{ type }}</span>
          </div>
          <div
            class="drag-btn"
            @mousedown.stop="startDrag"
            @touchstart.stop="startDrag"
            @mouseup="endDrag"
            @touchend="endDrag"
          >
            <v-icon>mdi-dots-grid</v-icon>
          </div>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                v-if="authUser.isAdmin"
                cols="12"
                sm="6"
              >
                <v-autocomplete
                  v-model="value.product"
                  dense
                  :items="['oem', 'fleet']"
                  item-text="name"
                  item-value="id"
                  :disabled="type == 'edit'"
                  :label="$t('select_product_*')"
                  :rules="[rules.required]"
                  @change="() => delete value.tenant_id"
                />
              </v-col>
              <v-col
                v-if="authUser.isAdmin"
                cols="12"
                sm="6"
              >
                <v-autocomplete
                  v-model="value.tenant_id"
                  dense
                  :items="tenantsByProduct"
                  :disabled="type == 'edit'"
                  item-text="name"
                  item-value="id"
                  :label="$t('select_tenant_*')"
                  :rules="[rules.required]"
                  @change="callDependent"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-autocomplete
                  v-model="value.type"
                  dense
                  :items="['vehicles', 'groups']"
                  :label="'Type *'"
                  :disabled="type == 'edit'"
                  :rules="[rules.required]"
                  @change="callDependent"
                />
              </v-col>
              <v-col
                v-if="value.type == 'vehicles'"
                cols="12"
                sm="6"
              >
                <div class="allVehicleSelect">
                  <v-autocomplete
                    v-model="value.vehicle_ids"
                    dense
                    :loading="isVehicles"
                    :items="value.tenant_id ? vehiclesList : []"
                    :label="$t('select_vehicles_*')"
                    item-text="vehicle_name"
                    item-value="id"
                    multiple
                    :rules="[rules.multi_select_required]"
                  >
                    <template v-slot:selection="data">
                      <span
                        v-if="data.index === 0"
                        class="selected"
                      >
                        <span>{{ data.item.vehicle_name }}</span>
                      </span>
                      <span
                        v-if="data.index === 1"
                        class="grey--text text-caption"
                      >
                        (+{{ value.vehicle_ids.length - 1 }}... )
                      </span>
                    </template>
                  </v-autocomplete>
                </div>
              </v-col>
              <v-col
                v-else-if="value.type == 'groups'"
                cols="12"
                sm="6"
              >
                <v-autocomplete
                  v-model="value.group_ids"
                  dense
                  :loading="isGroups"
                  :items="value.tenant_id ? groupsList : []"
                  :label="$t('select_groups_*')"
                  item-text="group_name"
                  item-value="id"
                  multiple
                  :rules="[rules.multi_select_required]"
                >
                  <template v-slot:selection="data">
                    <span
                      v-if="data.index === 0"
                      class="selected"
                    >
                      <span>{{ data.item.group_name }}</span>
                    </span>
                    <span
                      v-if="data.index === 1"
                      class="grey--text text-caption"
                    >
                      (+{{ value.group_ids.length - 1 }}... )
                    </span>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  v-model="value.name"
                  dense
                  :label="$t('geofence_name_*')"
                  :rules="[rules.required]"
                />
              </v-col>
              <!-- <v-col
                cols="12"
                sm="6"
              >
                <v-autocomplete
                  v-model="value.geofence_track"
                  dense
                  :items="['in', 'out']"
                  :label="$t('geofence_track_*')"
                  :rules="[rules.required]"
                />
              </v-col> -->
              <v-col
                cols="12"
                sm="6"
              >
                <v-select
                  v-model="value.geofence_type"
                  dense
                  :disabled="type == 'edit'"
                  label="Geofence Type *"
                  :items="['polygon', 'circle']"
                  :rules="[rules.required]"
                />
              </v-col>
              <v-col
                v-if="value.geofence_type === 'circle'"
                cols="12"
                sm="6"
              >
                <v-text-field
                  v-model="value.circle_radius"
                  dense
                  label="Circle
                Radius (meters)"
                  type="number"
                  min="10"
                  :rules="[rules.required]"
                  @change="(v) => $emit('updateRadius', v)"
                />
              </v-col>
            </v-row>
            <!-- Polygon Lat Lng -->
            <v-row v-if="value.geofence_type === 'polygon'">
              <template v-for="(r, i) in value.points">
                <v-col
                  :key="`${i}'-lat'`"
                  cols="6"
                  md="6"
                >
                  <v-text-field
                    v-model="value.points[i].lat"
                    dense
                    :disabled="value.geofence_type === 'circle'"
                    :label="$t('latitude_*')"
                    type="number"
                    :rules="[rules.required]"
                  />
                </v-col>
                <v-col
                  :key="`${i}'-lng'`"
                  cols="6"
                  md="6"
                  class="d-flex gap5"
                >
                  <v-text-field
                    v-model="value.points[i].lng"
                    dense
                    :disabled="value.geofence_type === 'circle'"
                    :label="$t('longitude_*')"
                    type="number"
                    :rules="[rules.required]"
                  />
                  <div
                    v-if="value.geofence_type === 'polygon'"
                    class="action-btn d-flex"
                  >
                    <v-icon
                      v-if="!value.points[i + 1]"
                      @click="() => value.points.push({})"
                    >
                      mdi-plus
                    </v-icon>
                    <v-icon
                      v-if="i > 0 || value.points[i + 1]"
                      @click="() => value.points.splice(i, 1)"
                    >
                      mdi-delete
                    </v-icon>
                  </div>
                </v-col>
              </template>
              <v-col
                v-if="value.geofence_type === 'polygon'"
                cols="12"
                sm="12"
              >
                <v-btn
                  color="primary"
                  block
                  @click="() => $emit('addGeofence')"
                >
                  Add Geofence
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </div>
      <v-card-actions>
        <v-btn
          color="primary"
          :loading="loading"
          block
          @click="saveItem"
        >
          {{ type == "edit" ? "Update" : "Save" }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>
<script>
import { validationRules } from "@/mixins/validationRules";
import { mapGetters } from "vuex";
export default {
  name: "AddGeofence",
  mixins: [validationRules],
  props: {
    value: {
      type: Object,
      default() {
        return {};
      },
    },
    type: {
      type: String,
      default() {
        return "title";
      },
    },
  },
  computed: {
    ...mapGetters({
      authUser: "getUser",
      loading: "geofence/getLoading",
      tenantsOEM: "tenantsManagement/getTenantsOEM",
      tenantsFLEET: "tenantsManagement/getTenantsFLEET",
      //
      isVehicles: "vehicles/getIsLoadingVehicles",
      vehiclesList: "vehicles/getVehiclesList",
      isGroups: "vehicles/getIsLoadingGroup",
      groupsList: "vehicles/getGroupsList",
    }),
    tenantsByProduct() {
      if (this.value?.product) {
        if (this.value?.product == "oem") {
          return this.tenantsOEM;
        } else {
          return this.tenantsFLEET;
        }
      } else {
        return [];
      }
    },
  },
  mounted() {
    if (this.authUser.isAdmin) {
      this.$store.dispatch("tenantsManagement/options", {}); // when refresh the page Tenant disappear
    } else {
      this.value.product = this.authUser.user_nature;
      this.value.tenant_id =
        this.authUser.user_nature == "oem"
          ? this.authUser.tenant_id
          : this.authUser.independent_fleet_user_nature
          ? this.authUser.tenant_id
          : this.authUser.parent_tenant_id;
    }
    setTimeout(() => {
      if (this.type == "edit") {
        if (this.value.tenant_id && this.value.type) {
          if (this.value.type == "vehicles") this.getVehicles();
          else if (this.value.type == "groups") this.getGroups();
        }
      }
    }, 1500);
  },
  methods: {
    callDependent() {
      delete this.value.vehicle_ids;
      delete this.value.group_ids;
      if (this.value.tenant_id && this.value.type) {
        if (this.value.type == "vehicles") this.getVehicles();
        else if (this.value.type == "groups") this.getGroups();
      }
    },
    getVehicles() {
      const params = {
        tenant_id: this.value.tenant_id,
      };
      this.$store.dispatch("vehicles/vehicleDropDown", params);
    },
    getGroups() {
      const params = {
        tenant_id: this.value.tenant_id,
        // child_group_detail: 1,
      };
      this.$store.dispatch("vehicles/groupDropDown", params);
    },
    async saveItem() {
      if (this.$refs.form.validate()) {
        this.$emit("onSave", this.value);
      }
    },
    async redirect() {
      const qry = await this.$store.dispatch(
        "redirect/getQueryParams",
        "geofence"
      );
      await this.$router.push({ name: "geofence", query: qry });
    },
    // Move
    startDrag(e) {
      e.stopPropagation();

      const box = this.$refs.controlBox;
      const parent = box.parentElement;

      const offsetX = e.clientX - box.getBoundingClientRect().left;
      const offsetY = e.clientY - box.getBoundingClientRect().top;

      const parentRect = parent.getBoundingClientRect();
      // const boxRect = box.getBoundingClientRect();

      const onMouseMove = (e) => {
        let newLeft = e.clientX - offsetX;
        let newTop = e.clientY - offsetY;

        // Ensure the box stays within the parent boundaries
        const maxLeft = parentRect.width - box.offsetWidth;
        const maxTop = parentRect.height - box.offsetHeight;

        if (newLeft < 0) newLeft = 0;
        if (newTop < 0) newTop = 0;
        if (newLeft > maxLeft) newLeft = maxLeft;
        if (newTop > maxTop) newTop = maxTop;

        box.style.left = `${newLeft}px`;
        box.style.top = `${newTop}px`;
      };

      const onMouseUp = () => {
        document.removeEventListener("mousemove", onMouseMove);
        document.removeEventListener("mouseup", onMouseUp);
      };

      document.addEventListener("mousemove", onMouseMove);
      document.addEventListener("mouseup", onMouseUp);
    },

    endDrag() {
      // No need to disable/enable map dragging if we stop propagation properly
    },
  },
};
</script>
<style lang="sass" scoped>
.geofence-form
  height: 100% !important
.geofence-card
  height: inherit !important
  overflow-y: auto
  display: flex
  flex-direction: column
  justify-content: space-between
.action-btn
  cursor: pointer

.selected
  text-wrap: nowrap
  overflow: hidden
  width: 40%
  margin-right: 0.5rem
  text-overflow: ellipsis

.drag-btn
  cursor: all-scroll !important

.redirect-btn
  cursor: pointer
  padding: 2px 3px
  border-radius: 5px
  &:hover
    color: #20a390
</style>
